// Cliente del API de streaming en directo de sesiones VR.
//
// Dos cosas distintas:
//   1. GET /revi/motricity/live/turn-credentials: obtiene iceServers (TURN
//      ephemeral via Cloudflare o fallback STUN) para pasar al
//      RTCPeerConnection del viewer.
//   2. buildWsUrl(): construye la URL WS al endpoint generico de signaling.
//      No abre el WS aqui (el componente lo hace). Pasamos el JWT por query
//      string `?token=...` porque los browsers no permiten cabeceras en WS.

import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviLiveStreamApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
  }

  async getTurnCredentials(token) {
    const url = `${this.baseApi}/revi/motricity/live/turn-credentials`;
    const r = await fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
    if (!r.ok) {
      const text = await r.text().catch(() => "");
      throw new Error(`turn-credentials ${r.status} ${text.slice(0, 200)}`);
    }
    return r.json();
  }

  // Convierte la URL base de HTTP a WS y compone el path generico.
  // adapterSlug por defecto "revi-motricity"; el resto de verticales
  // (cuando existan) pasaran el suyo.
  buildWsUrl({ code, token, adapterSlug = "revi-motricity" }) {
    const baseHttp = this.baseApi; // ej "https://canary.api.educa360.net/api/v1"
    const wsBase = baseHttp.replace(/^http/, "ws");
    const qs = token ? `?token=${encodeURIComponent(token)}` : "";
    return `${wsBase}/live-stream/${adapterSlug}/${encodeURIComponent(code)}${qs}`;
  }
}
